import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import InvoiceComponent from './invoice.component';

import { HomeActions } from 'modules/home/home.redux';

import {
  selectSendingStatus,
  selectSuccessStatus,
  selectFailureStatus,
} from 'modules/home/home.selector';

const mapStateToProps = createStructuredSelector({
  invoiceFormLoading: selectSendingStatus,
  invoiceFormSuccess: selectSuccessStatus,
  invoiceFormFailure: selectFailureStatus,
});

export const mapDispatchToProps = (dispatch) => bindActionCreators({
  invoiceFormReset: HomeActions.buyFormReset,
  invoiceFormRequest: HomeActions.buyFormRequest,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceComponent);


// WEBPACK FOOTER //
// ./src/routes/invoice/invoice.container.js